/**
 * PilotCarIcon — a saluting pilot figure next to a sleek car.
 * Drop-in replacement for Phosphor's <Airplane /> icon.
 * Accepts `size`, `weight` ("fill" toggles solid styling), `className`, `style`.
 */
const PilotCarIcon = ({
  size = 24,
  weight = "duotone",
  className = "",
  style = {},
  ...rest
}) => {
  const stroke = weight === "fill" ? 1.5 : 1.4;
  // For "fill" weight we render the bodies/wheels filled; for duotone they are outlined.
  const carBodyFill = weight === "fill" ? "currentColor" : "none";
  const headFill = weight === "fill" ? "currentColor" : "none";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      aria-hidden="true"
      {...rest}
    >
      {/* ===== Pilot (left), saluting ===== */}
      <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        {/* Cap brim */}
        <path
          d="M3.2 10.6 H15"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Cap (rounded trapezoid) */}
        <path
          d="M5 10.4 V8.6 Q5 6.4 7.4 6.4 H10.6 Q13 6.4 13 8.6 V10.4 Z"
          strokeWidth={stroke}
          fill={weight === "fill" ? "currentColor" : "none"}
        />
        {/* Cap badge dot */}
        <circle cx="9" cy="8.6" r="0.7" fill="currentColor" />
        {/* Head */}
        <circle
          cx="9"
          cy="13.6"
          r="2.2"
          strokeWidth={stroke}
          fill={headFill}
        />
        {/* Body / shoulders */}
        <path
          d="M5.6 22 Q5.6 17.2 9 17.2 Q12.4 17.2 12.4 22"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Saluting arm (right hand to forehead) */}
        <path
          d="M11.4 17.6 L13.2 13.6 L11.2 12"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Resting left arm */}
        <path
          d="M6.6 18 L5.6 22.4"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Legs */}
        <path d="M7.2 22 L6.6 28" strokeWidth={stroke} />
        <path d="M10.8 22 L11.4 28" strokeWidth={stroke} />
      </g>

      {/* ===== Car (right) ===== */}
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Roof + cabin */}
        <path
          d="M19.2 21.6 L21.2 17.4 Q22 16.4 23.2 16.4 H32.4 Q33.6 16.4 34.4 17.4 L36.4 21.6"
          strokeWidth={stroke}
          fill="none"
        />
        {/* Cabin pillar */}
        <path
          d="M27.6 16.6 L27.6 21.4"
          strokeWidth={stroke * 0.85}
          fill="none"
        />
        {/* Body */}
        <path
          d="M18 22 H37.6 V25 Q37.6 26.2 36.4 26.2 H19.2 Q18 26.2 18 25 Z"
          strokeWidth={stroke}
          fill={carBodyFill}
        />
        {/* Wheels */}
        <circle
          cx="22"
          cy="26.6"
          r="2.1"
          strokeWidth={stroke}
          fill={weight === "fill" ? "currentColor" : "rgba(0,0,0,0.0)"}
        />
        <circle
          cx="33.6"
          cy="26.6"
          r="2.1"
          strokeWidth={stroke}
          fill={weight === "fill" ? "currentColor" : "rgba(0,0,0,0.0)"}
        />
        {/* Wheel hubs */}
        <circle cx="22" cy="26.6" r="0.55" fill="currentColor" />
        <circle cx="33.6" cy="26.6" r="0.55" fill="currentColor" />
        {/* Headlight glint */}
        <circle cx="36.6" cy="23.4" r="0.45" fill="currentColor" />
      </g>
    </svg>
  );
};

export default PilotCarIcon;
